<template>
  <div class="home_wrap">
    <van-nav-bar :title="$t('支持')" left-text="" left-arrow :fixed="true" @click-left="onClickLeft" />
    <van-tabs v-model="active" class="van-tabs__wrap--scrollable" :swipeable="true" :swipe-threshold="2"
      line-width="1.5rem" background="transparent" :color="'#fff0bb'" @change="tabChange">
      <van-tab :title="$t('支持')" />
      <van-tab :title="$t('消息')" />
      <van-tab :title="$t('通知')" />
      <van-tab :title="$t('滚动面板')" />
      <van-tab :title="$t('建议')" />
    </van-tabs>
    <div v-if="active == 0" class="tabContent">
      <div class="support">
        <div class="support_item">
          <div class="support_info_img">
            <img src="https://cdn.bz999xyz.xyz/messageCenter/img_kf_kf01.png" alt="">
          </div>
          <div class="support_info_des">
            <div>{{ $t("在线支持") }} 24/7</div>
            <div>
              {{ $t("与专业客服在线聊天解决您的问题") }}
            </div>
            <div @click="Tolin(support_list.group_telegram)">
              {{ $t("线路") }} 1
            </div>
          </div>
        </div>
        <div v-for="item in support_list.custservice" :key="item.id" class="support_list">
          <div class="support_title">
            <div class="support_title_item">
              <img :src="item.image" alt="">
              {{ item.name }}
            </div>
          </div>
          <div class="support_list_item">
            <img :src="item.image" alt="">
            <div class="support_list_item_info">
              <div v-html="item.content" />
            </div>
            <div class="support_list_btn" @click="Tolin(item.url)">
              {{ $t("立即联系") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active == 1" class="tabContent">
      <div v-if="redContent == ''" class="platform">
        <div v-if="LetterList.service.length" v-for="item in LetterList.service" :key="item.id" class="platform-list">
          <div class="platform-list-item">
            <div class="platform-list-item-right">
              <div class="platform-list-item-right-icon">
                <div class="svg-icon">
                  <svg width="21" height="21" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2992_71739)">
                      <path
                        d="M2.60449 15.7822H39.3969V37.0773C39.3969 39.1614 37.7074 40.851 35.6233 40.851H6.37813C4.294 40.851 2.60449 39.1614 2.60449 37.0773V15.7822Z"
                        fill="" />
                      <path
                        d="M19.7896 1.01218C20.4902 0.426319 21.5098 0.426321 22.2104 1.01218L38.6635 14.771C40.016 15.902 39.2162 18.1052 37.4531 18.1052H4.54692C2.7838 18.1052 1.984 15.902 3.33653 14.771L19.7896 1.01218Z"
                        fill="" />
                      <rect x="4.49023" y="13.9268" width="33.0189" height="25.9972" rx="3.77363" fill=""
                        class="svg_rect" />
                      <path
                        d="M19.8201 25.5887C20.5093 25.0373 21.4886 25.0373 22.1778 25.5887L36.8162 37.3016C38.2088 38.4158 37.4209 40.6616 35.6374 40.6616H6.36049C4.577 40.6616 3.7891 38.4158 5.18167 37.3016L19.8201 25.5887Z"
                        fill="" />
                      <path d="M21.8709 24.5545L38.4685 17.7651L37.5098 38.0649L21.8709 24.5545Z" fill="" />
                      <path d="M20.2789 24.5558L3.68136 17.7663L4.49023 38.0674L20.2789 24.5558Z" fill="" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2992_71739">
                        <rect width="42" height="42" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div class="platform-list-item-right-content">
                <div class="platform-list-item-right-content-title">
                  {{ item.title }}
                </div>
                <div class="platform-list-item-right-content-time">
                  {{ item.createtime }}
                </div>
              </div>
            </div>
            <div class="platform-list-item-left" @click="red(item.id)">
              <span class="platform-list-item-left-desc">{{ $t("读") }}</span>
              <div class="svg-icon colorSvg" style="width: 0.3rem; height: 0.3rem">
                <svg viewBox="64 64 896 896" focusable="false" fill="#fff" aria-hidden="true">
                  <path
                    d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                    class="rightSvg" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <Empty />
        </div>
      </div>
      <div v-if="redContent !== ''" v-html="redContent" />
    </div>
    <div v-if="active == 2" class="tabContent">
      <div v-if="redContent == ''" class="platform">
        <div class="platform-list">
          <div v-for="item in LetterList.user" :key="item.id" class="platform-list-item">
            <div class="platform-list-item-right">
              <div class="platform-list-item-right-icon">
                <div class="svg-icon">
                  <svg width="21" height="21" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2992_71739)">
                      <path
                        d="M2.60449 15.7822H39.3969V37.0773C39.3969 39.1614 37.7074 40.851 35.6233 40.851H6.37813C4.294 40.851 2.60449 39.1614 2.60449 37.0773V15.7822Z"
                        fill="" />
                      <path
                        d="M19.7896 1.01218C20.4902 0.426319 21.5098 0.426321 22.2104 1.01218L38.6635 14.771C40.016 15.902 39.2162 18.1052 37.4531 18.1052H4.54692C2.7838 18.1052 1.984 15.902 3.33653 14.771L19.7896 1.01218Z"
                        fill="" />
                      <rect x="4.49023" y="13.9268" width="33.0189" height="25.9972" rx="3.77363" fill=""
                        class="svg_rect" />
                      <path
                        d="M19.8201 25.5887C20.5093 25.0373 21.4886 25.0373 22.1778 25.5887L36.8162 37.3016C38.2088 38.4158 37.4209 40.6616 35.6374 40.6616H6.36049C4.577 40.6616 3.7891 38.4158 5.18167 37.3016L19.8201 25.5887Z"
                        fill="" />
                      <path d="M21.8709 24.5545L38.4685 17.7651L37.5098 38.0649L21.8709 24.5545Z" fill="" />
                      <path d="M20.2789 24.5558L3.68136 17.7663L4.49023 38.0674L20.2789 24.5558Z" fill="" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2992_71739">
                        <rect width="42" height="42" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div class="platform-list-item-right-content">
                <div class="platform-list-item-right-content-title">
                  {{ item.title }}
                </div>
                <div class="platform-list-item-right-content-time">
                  {{ item.createtime }}
                </div>
              </div>
            </div>
            <div class="platform-list-item-left" @click="red(item.id)">
              <span class="platform-list-item-left-desc">{{ $t("已读") }}</span>
              <div class="svg-icon colorSvg" style="width: 0.3rem; height: 0.3rem">
                <svg viewBox="64 64 896 896" focusable="false" fill="#fff" aria-hidden="true">
                  <path
                    d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                    class="rightSvg" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="redContent !== ''" v-html="redContent" />
    </div>
    <div v-if="active == 3" class="tabContent">
      <div v-if="redContent == ''" class="platform">
        <div v-for="item in LetterList.painel" :key="item.id" class="platform-list" @click="red(item.id)">
          <div class="platform-list-item" style="padding: 0.4rem 0.2rem">
            <div class="platform-list-item-right" style="flex: 1">
              <div class="platform-list-item-right-icon">
                <div>
                  <svg width="26" height="16" viewBox="0 0 65 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0 39.0001V17C0 15.8954 0.89543 15 2 15H14L29.2404 2.64292C30.5478 1.58289 32.5 2.51332 32.5 4.19644V51.8036C32.5 53.4867 30.5478 54.4172 29.2404 53.3571L14 41.0001H2C0.895432 41.0001 0 40.1046 0 39.0001Z"
                      fill="var(--cms-background-color-secondary)" class="svg_path_pa" />
                    <path d="M39 18L40.5958 19.5198C45.4779 24.1695 45.5725 31.9275 40.8052 36.6948L39 38.5" stroke=""
                      class="svg_path_st" stroke-width="5" stroke-linecap="round" />
                    <path d="M46.5 10V10C56.6343 19.8604 56.6343 36.1396 46.5 46V46" stroke="" class="svg_path_st"
                      stroke-width="5" stroke-linecap="round" />
                  </svg>
                </div>
              </div>
              <div class="platform-list-item-right-content" style="max-width: 8rem">
                <div class="platform-list-item-right-content-title">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="platform-list-item-left">
              <div class="svg-icon colorSvg" style="width: 0.3rem; height: 0.3rem">
                <svg viewBox="64 64 896 896" focusable="false" fill="#fff" aria-hidden="true">
                  <path
                    d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                    class="rightSvg" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="redContent !== ''" v-html="redContent" />
    </div>
    <div v-if="active == 4" class="tabContent">
      <div class="fdback">
        <div class="fdback-bg">
          <div class="fdback-bg-btn">
            {{ $t("创建反馈") }}
          </div>
          <div class="fdbackBg2">
            <div class="fdback-bg-desc1">
              <span>
                {{ $t("反馈内容") }}
              </span>
              ( {{ $t("提出改进建议") }})
            </div>
            <div>
              <van-field v-model="username" class="fdback-bg-input" placeholder="Por favor insira o título" />
            </div>
            <div>
              <van-field v-model="username" class="fdback-bg-input fdback-bg-main" type="textarea" maxlength="200"
                show-word-limit :placeholder="$t('tip11')" />
            </div>
            <div class="fdback-bg-desc2">
              {{ $t("奖励规则") }}
            </div>
            <div class="fdback-bg-desc1">
              {{ $t("tip10") }}
            </div>
          </div>
        </div>
        <div class="fdback-bwrap">
          <van-button type="primary" block>
            {{ $t("发送反馈") }}
          </van-button>
        </div>
      </div>
    </div>
    <!-- <div class="kefuym">
      <ul>
        <li v-for="(item, idx) in support_list" :key="idx">
          <div class="kefuym_tx"><img :src="item.image" alt="" /></div>
          <div class="kefuym_txt">
            <h2>{{ item.name }}</h2>
            <div v-html="item.content"></div>
            <a :href="item.url" target="_blank">Contate agora</a>
          </div>
          <div class="clear"></div>
        </li>
      </ul>
    </div> -->
    <!-- <ftNav :active="3" /> -->
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar, Tab, Tabs, Button } from "vant";
import { Form, Field, CellGroup } from "vant";
import Fetch from "../../utils/fetch";
import ftNav from "../../components/footer_nav/footer_nav";
import Empty from '../../components/empty.vue';
import { EventBus } from '../../utils/utils'
Vue.use(NavBar)
  .use(Tab)
  .use(Tabs)
  .use(Form)
  .use(Field)
  .use(CellGroup)
  .use(Button);
export default {
  name: "Support",
  props: {
    supTab: String
  },
  components: {
    ftNav,
    Empty
  },
  watch: {
    supTab(newval) {
      if (newval) {
        this.$nextTick(() => {
          this.active = newval;
          this.tabChange(Number(newval));
        });
      }
    }
  },
  data() {
    return {
      support_list: {},
      LetterList: {},
      active: 0,
      username: "",
      redContent: "",
      contenText:
        '<p>Bem-vindo ao aqui777<span style="font-size: 1em;">.com , plataforma brasileira de entretenimento on-line, altos bônus, depósitos e saques grandes e sem preocupações</span></p>',
    };
  },
  created() {
    this.$bus.$emit("send2ftnav", 3);
  },
  mounted() {
    this.tabChange(this.active);
    EventBus.$on('supTabChange', data => {
      console.log("supTabChange")
      this.active = data;
      this.tabChange(Number(data));
    })
  },
  methods: {
    start() {
      Fetch("/platform/support").then((r) => {
        this.support_list = r.data;
      });
    },
    getLetterList() {
      Fetch("/letter/list").then((r) => {
        this.LetterList = r.data;
      });
    },
    onClickLeft() {
      this.$parent.$parent.isShowSupport = false;
    },
    tabChange(v) {
      this.active = v;
      this.redContent = "";
      if (this.active == 0) {
        this.start();
      } else if (this.active == 1 || this.active == 2 || this.active == 3) {
        this.getLetterList();
      }
    },
    Tolin(v) {
      window.open(v);
    },
    red(v) {
      Fetch("/letter/read", {
        letter_id: v,
      }).then((r) => {
        // this.LetterList = r.data;
        if (r.data.content) {
          this.redContent = r.data.content;
          this.redContent = this.redContent
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")

            .replace(/&amp;/g, "&")
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'");
        } else {
          this.redContent = "";
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
  z-index: 111;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-tab__text {
  color: #fff;
  font-size: 0.3rem;
}

/deep/ .van-tabs__line {
  height: 0.03rem;
  background: @ButtonColor !important;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  border-bottom: 0.01rem solid @bodercolor;
}

/deep/ .van-hairline--bottom::after {
  border: none;
}

/deep/ .van-tabs__nav {
  background: @secondary-color !important;
}

.vantTabs {
  :deep(.van-tabs__wrap) {
    height: 0.88rem;

    .van-tabs__nav {
      padding-left: 0;
      padding-right: 0;
      background-color: @secondary-color;
    }

    .van-tab {
      padding: 0 0.2rem;

      .van-tab__text {
        font-size: 0.32rem;
      }

      &.van-tab--active {
        span {
          color: @rechargeColor;
        }
      }
    }

    .van-tabs__line {
      background-color: @rechargeColor;
    }
  }
}

.support {
  // width: 100%;
  padding: 0 0.2rem;
  padding-bottom: 1rem;
  box-sizing: border-box;

  .support_item {
    // width: 100%;
    height: auto;
    background: @secondary-color;
    display: flex;
    padding: 0.16rem 0.24rem;
    border-radius: 0.08rem;
    margin-bottom: 0.2rem;
    margin-top: 0.2rem;

    .support_info_img {
      width: 1rem;
      height: 1rem;
      border-radius: 100%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .support_info_des {
      flex: 1;
      margin-left: 0.16rem;
    }

    .support_info_des div:first-of-type {
      font-weight: 400;
      font-size: 0.42rem;
      color: #fff;
      line-height: 0.7rem;
    }

    .support_info_des div:nth-of-type(2) {
      font-weight: 400;
      font-size: 0.3rem;
      color: @popupTextColor;
      line-height: 0.36rem;
      margin-top: 0.14rem;
    }

    .support_info_des div:nth-of-type(3) {
      width: 1.76rem;
      height: 0.5rem;
      border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
      border: 0.02rem solid @ButtonColor;
      color: @ButtonColor;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.12rem;
      font-size: 0.3rem;
    }
  }

  .support_list {
    // width: 100%;
    padding: 0 0.24rem 0.2rem 0.24rem;
    margin-top: 0.2rem;
    background: @secondary-color;
    margin-bottom: 0.2rem;
    border-radius: 0.08rem;
    box-sizing: border-box;

    .support_title {
      width: 100%;
      height: 0.66rem;
      border-bottom: 0.02rem solid @bodercolor;
      display: flex;

      .support_title_item {
        position: relative;
        height: 100%;
        color: @ButtonColor;
        display: flex;
        align-items: center;
        font-size: 0.3rem;
        flex-shrink: 0;

        img {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.12rem;
        }
      }

      .support_title_item:after {
        content: "";
        width: 100%;
        position: absolute;
        bottom: -0.02rem;
        height: 0.04rem;
        background: @ButtonColor;
      }
    }

    .support_list_item {
      // width: 100%;
      height: auto;
      display: flex;
      padding: 0.14rem 0.3rem 0.16rem 0.2rem;
      align-items: center;
      background: rgba(0, 0, 0, 0.2);
      margin-top: 0.2rem;
      border-radius: 0.08rem;

      img {
        width: 1rem;
        height: 1rem;
        margin-right: 0.2rem;
      }

      .support_list_item_info {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 0.3rem;
        color: @popupTextColor;
        flex-wrap: wrap;
      }

      .support_list_btn {
        width: 1.5rem;
        height: 0.8rem;
        background: @ButtonColor;
        color: @textcolor6;
        font-size: 0.28rem;
        border-radius: 0.08rem;
        text-align: center;
        line-height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.platform {
  margin: 0.2rem 0.22rem;

  .platform-list {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin-bottom: 0.3rem;

    .platform-list-item {
      padding: 0.26rem 0.2rem;
      display: flex;
      justify-content: space-between;
      background: @secondary-color;
      border-radius: 0.1rem;

      .platform-list-item-right {
        display: flex;
        align-items: center;
        gap: 0.2rem;

        .platform-list-item-right-icon {
          width: auto;

          .svg-icon {
            width: 0.38rem;
            height: 0.38rem;
            color: @ButtonColor;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}

svg path {
  fill: @bodercolor;
}

.svg_rect {
  fill: @ButtonColor;
}

.platform-list-item-right-content {
  display: flex;
  flex-direction: column;
  max-width: 4.46rem;
  overflow: hidden;
  white-space: nowrap;
  line-height: normal;

  .platform-list-item-right-content-title {
    font-size: 0.34rem;
    color: #fff;
    font-weight: 500;
  }

  .platform-list-item-right-content-time {
    font-size: 0.28rem;
    color: @popupTextColor;
  }
}

.platform-list-item-left {
  display: flex;
  align-items: center;
  gap: 0.16rem;
}

.platform-list-item-left-desc {
  font-size: 0.34rem;
  color: #fff;
}

.colorSvg {
  color: @popupTextColor !important;
}

.rightSvg {
  fill: #fff !important;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: @activityColor;
  padding-top: 1.2rem;
}

.svg_path_pa {
  fill: @vipTextMoneyColor;
}

.svg_path_st {
  fill: @ButtonColor;
}

.fdback {
  width: 100%;
  padding-bottom: 1.5rem;
  box-sizing: border-box;

  .fdback-bg {
    width: 100%;
    overflow: hidden;
    padding: 0 0.2rem 0.2rem 0.2rem;
    box-sizing: border-box;

    .fdback-bg-btn {
      width: 1.8rem;
      height: 0.8rem;
      background: @ButtonColor;
      border-radius: 1.8rem 1.8rem 1.8rem 1.8rem;
      font-weight: 400;
      font-size: 0.3rem;
      color: @textcolor6;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      text-align: center;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .fdbackBg2 {
      background: @secondary-color;
      padding: 0.2rem;
      border-radius: 0.16rem;

      .fdback-bg-desc1 {
        width: 100%;
        font-size: 0.3rem;
        color: @popupTextColor;
        margin-bottom: 0.24rem;
        line-height: 0.4rem;

        span {
          color: #ffffff;
          margin-right: 0.04rem;
        }
      }

      .fdback-bg-input {
        background: @secondary-color !important;
        border-radius: 0.16rem;
        border: 0.02rem solid @bodercolor;
        color: #ffff;
      }
    }
  }
}

/deep/.van-field__control {
  color: #fff !important;
  font-size: 0.25rem !important;
}

/deep/textarea.van-field__control {
  height: 3.4rem;
  // border: 0.02rem solid @bodercolor;
  padding: 0.4rem;
  border-radius: 0.16rem;
  background: @secondary-color;

  // line-height: 1.5;
}

/deep/ .van-field__word-limit {
  color: #fff !important;
  font-size: 0.22rem;
}

/deep/.van-field__word-num {
  color: #fff !important;
}

/deep/.van-button--primary {
  background-color: @rechargeColor;
  border-radius: 0.33rem;
  border: none;
  height: 1rem;
}

/deep/.van-button__text {
  color: @textcolor6 !important;
}

.fdback-bg-main {
  margin-top: 0.24rem;
  // height: 3.6rem;
  border-radius: 0;
  border: none;
  padding: 0 !important;
  background: none;
  overflow: initial;
}

.fdback-bg-desc2 {
  width: 100%;
  font-size: 0.3rem;
  color: #fff;
  margin-top: 0.64rem;
  margin-bottom: 0.12rem;
}

.fdback-bwrap {
  padding: 0.2rem 0.2rem 0.3rem 0.2rem;
  width: 100%;
  height: 1.3rem;
  // background: @gradientColorEnd;
  box-sizing: border-box;
}
</style>
